import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

/** Birth date must be under 13 years old */
export function coppaDobValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {

        var isInvalidCoppaDate = false;
        var dob = control.value;
        if (dob != null) {
            var timestamp = Date.parse(dob);

            if (!isNaN(timestamp)) {

                var date = new Date(dob);

            
                isInvalidCoppaDate = (calculateAge(date) < 13);
            

            }
        }





        return isInvalidCoppaDate ? { 'coppaDob': { value: control.value } } : null;
    };
}


export function calculateAge(birthday: Date) { // birthday is a date
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}



@Directive({
    selector: '[coppaDob]',
    providers: [{ provide: NG_VALIDATORS, useExisting: CoppaDobValidatorDirective, multi: true }]
})
export class CoppaDobValidatorDirective implements Validator {
    @Input()
    coppaDob: boolean;

    validate(control: AbstractControl): { [key: string]: any } {
        if (this.coppaDob)
            return coppaDobValidator()(control);
        return null;
    }
}

